export function TasksPage({ render }) {
  return render();
}
